export default __webpack_public_path__ + "static/media/cprofile7.b9be5919.png";